import { contactInfo } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-3xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center">
          联系我们
        </h2>
        <p className="mt-2 text-sm text-foreground-600 text-center">
          片荒投稿 · 意见反馈 · 商务合作
        </p>

        <div className="mt-10 rounded-2xl bg-background-100 border border-background-200/70 p-6 md:p-10">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center">
              <i className="ri-mail-send-fill text-lg text-accent-600"></i>
            </div>
            <h3 className="font-heading text-lg font-bold text-foreground-950">
              {contactInfo.title}
            </h3>
          </div>
          <p className="text-sm text-foreground-600 leading-relaxed">
            {contactInfo.desc}
          </p>
          <div className="mt-6 grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="flex items-center gap-3 p-4 rounded-xl bg-background-50 border border-background-200/70">
              <i className="ri-mail-line text-xl text-primary-500"></i>
              <div>
                <p className="text-[11px] text-foreground-500">电子邮箱</p>
                <p className="text-sm font-medium text-foreground-900">{contactInfo.email}</p>
              </div>
            </div>
            <div className="flex items-center gap-3 p-4 rounded-xl bg-background-50 border border-background-200/70">
              <i className="ri-wechat-fill text-xl text-accent-500"></i>
              <div>
                <p className="text-[11px] text-foreground-500">微信公众号</p>
                <p className="text-sm font-medium text-foreground-900">{contactInfo.wechat}</p>
              </div>
            </div>
            <div className="flex items-center gap-3 p-4 rounded-xl bg-background-50 border border-background-200/70">
              <i className="ri-qq-fill text-xl text-secondary-500"></i>
              <div>
                <p className="text-[11px] text-foreground-500">QQ 交流群</p>
                <p className="text-sm font-medium text-foreground-900">{contactInfo.qq}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}